@if (message()) {
  <span class="text-light">{{ message() }}</span>
} @else if (url()) {
  <div class="source">
    @if (logoUrl()) {
      <img [src]="logoUrl()"
           [alt]="sourceName()" />
    } @else if (!isExternalLink()) {
      <img [src]="ezLynxLogoUrl"
           alt="EZLynx" />
    }
    <span class="source-name">{{ sourceName() }}</span>
  </div>

  <a [ezRouterLink]="url()"
     [attr.target]="openInNew() || isExternalLink() ? '_blank' : null"
     [attr.rel]="isExternalLink() ? 'noreferrer' : null"
     (click)="sourceClicked.emit()">
    {{ sourceText() }}
    @if (openInNew() || isExternalLink()) {
      <mat-icon small>open_in_new</mat-icon>
    }
  </a>
} @else if (sourceText()) {
  <div class="source">
    <img [src]="ezLynxLogoUrl"
         alt="EZLynx" />
    <span class="source-name">{{ sourceName() }}</span>
  </div>

  <button type="button"
          color="primary"
          matButton="tonal"
          (click)="sourceClicked.emit()">{{ sourceText() }}</button>
}